import React, { useState, useEffect, Fragment } from "react";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import axios from "axios";
import { server } from "../../config";
import parse from "html-react-parser";
import Head from "next/head";
import Link from "next/link";
import Container from "@mui/material/Container";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import Skeleton from "@mui/material/Skeleton";
import Title from '../../components/deal/title'
import Timings from '../../components/deal/timings'
import Venue from '../../components/deal/venue'
import DealTickets from '../../components/deal/tickets'
import AboutDeal from '../../components/deal/about'
import DealTerms from '../../components/deal/terms'
import DealImage from '../../components/deal/image'
import darkTheme from '../../src/theme';
import RelatedDeals from '../../components/RelatedDeals'
import { parseCookies } from "nookies";
import DealNavBar from '../../components/navbars/Custom'
import { useRouter } from "next/router";

const dealPageContainer = {
  marginBottom: darkTheme.spacing(5),
  marginTop: darkTheme.spacing(4),
  [darkTheme.breakpoints.down("sm")]: {
    marginTop: darkTheme.spacing(1),
  },
    '& h1': {
      fontSize: 25,
      color: darkTheme.palette.grey[200],
      fontWeight: 500,
      marginBottom: darkTheme.spacing(0.5),
      [darkTheme.breakpoints.down("md")]: {
        fontSize: 20,
      },
    },
    '& h4': {
      fontSize: 12,
      color: darkTheme.palette.grey[200],
      fontWeight: 400,
      textTransform: 'uppercase !important',
      marginBottom: darkTheme.spacing(0.5),
    },
  };

const breadCrump = {
  listStyle: 'none',
  fontSize: 14,
  color: darkTheme.palette.grey[200],
  paddingLeft: 0,
  textTransform: 'capitalize',
  [darkTheme.breakpoints.down("md")]: {
    display: 'none'
  },
};
const items = {
  display: 'inline',  
  fontSize: 14,
  '& a': {
    color: darkTheme.palette.grey[600],
    textTransform: 'capitalize',          
    '& hover': {
      color: darkTheme.palette.grey[200]
    }
  }
};


export const getStaticProps = async function (context) {
  try {    
    let slug = context.params ? context.params.slug[0] : "";
    let id = context.params ? context.params.slug[1] : "";          
  
    let res1 = await axios.get(
      `${server}/api/deals/details?slug=${slug}&id=${id}`,
      {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      }
    );
  
    const data = res1.data.result ? res1.data.result[0] : null;
    const url = `https://clubr.in/deal/${slug}/${id}`;
  
    const breadcrumbSchema = `{
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://clubr.in"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Deals",
        "item": "https://clubr.in/deals"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "${data.title ? data.title : ''}"
      }],
      "alternateName": "Deals",
      "description": "${data.description ? data.description : ''}",
      "image": "${data.img_path ? data.img_path : 'https://clubrstorage.blob.core.windows.net/clubr-img/default.jpg'}",
      "url": "${url}"
    }`
  
    return {
      props: {
        deal: res1.data.result ? res1.data.result[0] : null,
        slug: slug,
        id: id,
        // schema: schema,
        breadcrumbSchema: breadcrumbSchema,        
      },
      revalidate: 1,
    };
  } catch (e) {
    console.log(e);
    // return {notFound: true}
  }
};

export const getStaticPaths = async function () {
  try {
    let deal = [];
    deal["id"] = 220;
    deal["slug"] = "deal";
  
    const paths = deal.map((post) => ({
      params: {
        id: post.id,
        slug: post.slug,
      },
    }));
  
    return {
      paths,
      fallback: "blocking",
    };
  } catch (e) {
    console.log(e);
  }
};

function Slug(props) {   
  const [data, setData] = useState([]);
  let slug = props ? props.slug : "";
  let id = props ? props.id : "";
  const [deals, setDeals] = useState([]);
  const [tickets, setTickets] = useState([]);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [loading, setLoading] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [url, seturl] = useState("");
  let urls1 = ["home", "deals", data ? data.title : ''];  
  let urls2 = ['', 'deals', props.slug];
  const [cityName, setCityName] = useState('')
  const cookieCity = parseCookies();
  const Router = useRouter();

  useEffect(() => {
    const city = cookieCity.city ? cookieCity.city : '';   
    if (city) {
      setCityName(city)      
    } else {      
      setCityName('')
    }
  },[props])

  useEffect(() => {
    if(props.slug !== props.deal.slug){
      Router.push('/deal/'+props.deal.slug+'/'+props.deal.id)
    }

    setData(props.deal);
    setLoading(false);
    seturl(window.location.href);    
    if (document.getElementById("paytm-checkoutjs")) {
      document.getElementById("paytm-checkoutjs").style.display = "none";
    }    
  }, [props]);

  return (
    <>
    
      {loading ? (
        <Container>
          <Typography component="div" className="main_sec">
            <Grid container spacing={5} sx={{ pt: 5 }}>
              <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                <Skeleton
                  animation="wave"
                  variant="rectangular"
                  height={300}
                  sx={{ borderRadius: "20px", color: "grey.900" }}
                />
                <Stack
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexDirection: "row",
                    mt: 3,
                    mb: 3,
                  }}
                >
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={40}
                    height={40}
                    sx={{ color: "grey.900", mr: 2 }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={40}
                    height={40}
                    sx={{ color: "grey.900" }}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Skeleton
                  animation="wave"
                  variant="h1"
                  height={35}
                  sx={{ color: "grey.900" }}
                />
                <Skeleton
                  animation="wave"
                  variant="body1"
                  width={200}
                  sx={{ mt: 1, color: "grey.900" }}
                />
                <Skeleton
                  animation="wave"
                  variant="h3"
                  width="55%"
                  sx={{ mt: 3, color: "grey.900" }}
                />
                <Skeleton
                  animation="wave"
                  variant="h2"
                  height={100}
                  sx={{ borderRadius: "20px", mt: 3, color: "grey.900" }}
                />
                <Stack sx={{ mt: 5, mb: 5 }}>
                  <Skeleton
                    animation="wave"
                    variant="h2"
                    width="55%"
                    height={30}
                    sx={{ color: "grey.900" }}
                  />
                  <Stack sx={{ display: "flex", flexDirection: "row" }}>
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                    <Skeleton
                      animation="wave"
                      variant="h3"
                      sx={{
                        ml: 0,
                        mr: 1,
                        my: 1,
                        borderRadius: "20px",
                        color: "grey.900",
                      }}
                      height={50}
                      width={100}
                    />
                  </Stack>
                </Stack>
                <Stack sx={{ mt: 5, mb: 5 }}>
                  <Skeleton
                    animation="wave"
                    variant="h2"
                    width="55%"
                    height={30}
                    sx={{ color: "grey.900" }}
                  />
                  <Skeleton animation="wave" variant="body1" sx={{ mt: 2 }} />
                  <Skeleton animation="wave" variant="body1" sx={{ mt: 2 }} />
                  <Skeleton animation="wave" variant="body1" sx={{ mt: 2 }} />
                </Stack>
                <Stack sx={{ mt: 5, mb: 5 }}>
                  <Skeleton
                    animation="wave"
                    variant="h2"
                    width="55%"
                    height={30}
                    sx={{ color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="body1"
                    sx={{ mt: 2, color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="body1"
                    sx={{ mt: 2, color: "grey.900" }}
                  />
                  <Skeleton
                    animation="wave"
                    variant="body1"
                    sx={{ mt: 2, color: "grey.900" }}
                  />
                </Stack>
              </Grid>
            </Grid>
          </Typography>
        </Container>
      ) : (
        <Fragment>
          <Head>
            <title>{`Avail ${data.title ? data.title : ''} Deal at ${data.club_title ? data.club_title : ''}, ${data.cityName ? data.cityName : ''}  - Book now on Clubr`}</title>
            <meta
              name="description"
              content={`Checkout all deals from ${data.club_title ? data.club_title : ''}, ${data.cityName ? data.cityName : ''} and book the current deal ${data.title ? data.title : ''} in advance at clubr.`}
            ></meta>
            <meta
              property="og:title"
              content={`Avail ${data.title ? data.title : ''} Deal at ${data.club_title ? data.club_title : ''}, ${data.cityName ? data.cityName : ''}  - Book now on Clubr`}
            />
            <meta
              property="og:description"
              content={`Checkout all deals from ${data.club_title ? data.club_title : ''}, ${data.cityName ? data.cityName : ''} and book the current deal ${data.title ? data.title : ''} in advance at clubr.`}
            />
            <meta
              property="og:image"
              content={data.img_path ? data.img_path : 'https://clubrstorage.blob.core.windows.net/clubr-img/default.jpg'}
            />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Clubr" />
            <meta property="og:url" content={`https://clubr.in/deal/${data.slug}/${data.id}`} />
            <meta name="twitter:card" content="summary_large_image"></meta>
            <meta name="twitter:site" content="@Clubr14"></meta>
            <meta name="twitter:creator" content="@Clubr14"></meta>
            <meta name="twitter:title" content={`Avail ${data.title ? data.title : ''} Deal at ${data.club_title ? data.club_title : ''}, ${data.cityName ? data.cityName : ''}  - Book now on Clubr`}></meta>
            <meta name="twitter:description" content={`Checkout all deals from ${data.club_title ? data.club_title : ''}, ${data.cityName ? data.cityName : ''} and book the current deal ${data.title ? data.title : ''} in advance at clubr.`}></meta>
            <meta name="twitter:image" content={data.img_path ? data.img_path : 'https://clubrstorage.blob.core.windows.net/clubr-img/default.jpg'}></meta>

            <script
              type="application/ld+json"
              dangerouslySetInnerHTML={{ __html: props.breadcrumbSchema }}
            />
          </Head>
            <Typography component="div" sx={dealPageContainer} className={"main_sec"}>                       
              <Grid container>
                <Grid item xs={12}>                  
                  <Typography component="ul" sx={breadCrump}>
                    {cityName ? (
                      <>
                        <Typography component="li" sx={items}><Link href={`../${cityName}/home`}><a>Home / </a></Link></Typography>
                        <Typography component="li" sx={items}><Link href={`../${cityName}/deals`}><a>Deals / </a></Link></Typography>
                        <Typography component="li" sx={items}>{data.title}</Typography>
                      </>
                    ) : (
                       <>
                        <Typography component="li" sx={items}><Link href={`../`}><a>Home / </a></Link></Typography>
                        <Typography component="li" sx={items}><Link href={`../deals`}><a>Deals / </a></Link></Typography>
                        <Typography component="li" sx={items}>{data.title}</Typography>
                      </> 
                    )}
                    </Typography>                  
                </Grid>
              </Grid>            
              <Grid container>
                <Grid item xs={12} lg={5} md={6} sm={12}>
                  <DealImage data={data} />
                </Grid>
                <Grid
                  item
                  xs={12}
                  lg={6}
                  md={6}
                  sm={12}
                  sx={{
                    pl: {
                      md: 5,                    
                    },
                    mt: {
                      md: 2,
                      sm: 0
                    }
                  }}
                >
                  <Typography component="div">                                          
                    <Title data={data} url={url} />   
                    {/* {data.description.length > 0 ? (
                        <AboutDeal data={data} /> 
                      ) : ('')}   */}
                    <Timings data={data} /> 
                    <Venue data={data} /> 
                    <DealTickets
                      data={data}                          
                    />                          
                      
                      {parse(data.tc).length > 0 ? (
                        <DealTerms data={data} /> 
                      ) : ('')}                       
                  </Typography>
                </Grid>
              </Grid>            
            </Typography>
            <Typography component="div" className="mobileMode">
              <DealNavBar city={cityName ? cityName : ''} title={props.deal.title} url={'deals'} />
            </Typography>
            <Typography component="div" sx={{mt:3}}>
              <RelatedDeals slug={slug} id={id} city={cityName} />
            </Typography>  
        </Fragment>
      )}
    </>
  );
}

export default Slug;
